module.exports = __webpack_public_path__ + "img/blue_pencil.26c3c0a6.svg";